import { FC, RefObject } from 'react';
import { Icon, Divider, SmallLoader } from 'learning-panel-components';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import { translate } from 'translations';
import styles from './certificatePopup.module.scss';
import Certificate from './certificate';

const CertificatePopup: FC<CertificatePopupProps> = (props: CertificatePopupProps) => {
    const {
        onClose,
        certificateData,
        isCertificateDataLoading,
        handleLinkedinShare,
        refCert,
        certificateDataRef,
        isCertUploading,
        isCxUniversity,
        isOwasp,
        isBP,
        isCustom,
        isSkillTree,
        isLearningPath
    } = props;

    const handleDownloadPdf = async () => {
        let element;
        if (refCert?.current) {
            element = refCert.current;
            const canvas = await html2canvas(element, { scale: 5 });
            const data = canvas.toDataURL('image/png');

            const pdf = new JsPDF({ orientation: 'l', unit: 'pt', format: [canvas.width, canvas.height] });
            const imgProperties = pdf.getImageProperties(data);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

            pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);

            pdf.save('certificate.pdf');
        }
    };

    return (
        <div className={styles['background-wrapper']}>
            <div
                className={styles['account-settings-wrapper']}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/accountSettings.svg)` }}
            >
                <img alt="" src={`${process.env.PUBLIC_URL}/images/confetti.svg`} className={styles.image} />
                <div className={styles['top-wrapper']}>
                    <Icon name="cancel" onClick={onClose} className={styles.cancel} />
                </div>
                <div className={styles.bottom}>
                    <div className={styles.texts}>
                        <div className={styles.title}>{translate('Congratulations!')}</div>
                        <div className={styles.subtitle}>{translate('YourCertificateIsReady')}</div>
                    </div>
                    <div className={styles.divider}>
                        <Divider color="rgba(255, 255, 255, 0.25)" />
                    </div>
                    <div className={styles.buttons}>
                        {isCertUploading ? (
                            <div className={styles.button}>
                                <SmallLoader size="35px" />
                            </div>
                        ) : (
                            <div className={styles.button}>
                                <div className={styles.download} onClick={() => handleLinkedinShare()}>
                                    <Icon className={styles.share} name="linkedIn" />
                                    <div>{translate('Share')}</div>
                                </div>
                            </div>
                        )}
                        <div className={styles.button}>
                            <div className={styles.download} onClick={() => handleDownloadPdf()}>
                                <Icon name="download" />
                                <div>{translate('Download')}</div>
                            </div>
                        </div>
                    </div>
                    <Certificate
                        certificateData={certificateData}
                        isCxUniversity={isCxUniversity}
                        isCertificateDataLoading={isCertificateDataLoading}
                        refCert={refCert}
                        isCustom={isCustom}
                        isOwasp={isOwasp}
                        isBP={isBP}
                        isSkillTree={isSkillTree}
                        isLearningPath={isLearningPath}
                        width="33rem"
                        height="22rem"
                    />
                </div>
            </div>
        </div>
    );
};

interface CertificatePopupProps {
    onClose: Function;
    isCxUniversity: boolean;
    certificateData: {
        name: string;
        entityDisplayName: string;
        endDate?: string;
        completedAt?: string;
    };
    refCert?: RefObject<HTMLDivElement>;
    isCertificateDataLoading: boolean;
    handleLinkedinShare: Function;
    certificateDataRef?: (node: any) => void;
    isCertUploading: boolean;
    isOwasp: boolean;
    isCustom: boolean;
    isSkillTree: boolean;
    isLearningPath: boolean;
    isBP?: boolean;
}

export default CertificatePopup;
